import React from 'react';

import {BulkActionResult} from 'src/components/bulk-tool';

import {DischargeUsersEntitlementsResultModal} from './discharge-users-entitlements.result.modal';
import {
    clearResult,
    selectDischargeUsersEntitlementsBulkUuid,
    selectDischargeUsersEntitlementsShown,
    selectDischargeUsersEntitlementsTask,
} from './discharge-users-entitlements.slice';


export const DischargeUsersEntitlementsResult = () => (
    <BulkActionResult
        actionIdSelector={selectDischargeUsersEntitlementsBulkUuid}
        actionTaskSelector={selectDischargeUsersEntitlementsTask}
        actionShownSelector={selectDischargeUsersEntitlementsShown}
        clearResult={clearResult}>
        {({id, onClose}) => (
            <DischargeUsersEntitlementsResultModal id={id} onClose={onClose}/>
        )}
    </BulkActionResult>
);
